import { endpointService } from "components/shared/services/endpointService";
import { PickupEventConfig, PickupEventVariant } from "./types";

export const PAGE_SIZE = 10;

export const getConfig = (variant: PickupEventVariant): PickupEventConfig => {
  const isWps = variant === "wps";
  const basePath = isWps ? "/check-in/events" : "/pickup/events";
  const eventResource = endpointService.getCheckinEndpoint("eventResource");

  return {
    listResource: eventResource,
    detailResource: eventResource,
    dropdownResource: endpointService.getCheckinEndpoint("eventDropdown"),
    updateResource: eventResource,
    historyResource: (id) =>
      endpointService.getCheckinEndpoint("eventHistory", { id }),
    permissionResource: "events",
    permissionApp: isWps ? "check-in" : "pickup",
    basePath,
    detailPath: (id) => `${basePath}/${id}${isWps ? "/detail" : ""}`,
    editPath: (id) => `${basePath}/${id}/edit`,
  };
};
